import $ from 'jquery';

function addMobileClass() {
  $('body').addClass('mobile');
}

function removeMobileClass() {
  $('body').removeClass('mobile');
}

function isMobile(){
  return $(window).innerWidth() <= 768;
}

function isMaxHeight(){
  return $(window).innerWidth() >= 1440;
}

function wooButtons() {
  const buttons = document.querySelectorAll('.wc-forward');

  if(buttons) {
    buttons.forEach(button => {
      button.classList.add('btn', 'btn-primary');
    });
  }
}

function lastBlock() {
	const blocks = document.querySelectorAll('.page-container > section');

	if (blocks) {
		blocks.forEach(block => {
			if (!block.nextElementSibling) {
				block.classList.add('last-block');
			}
		});
	}
}

export {
	isMobile, 
	addMobileClass, 
	removeMobileClass, 
	isMaxHeight, 
	wooButtons,
	lastBlock
};
